import React, { useContext, useState, useEffect, useMemo } from "react";
import { Box, CircularProgress, Grid, Paper, TextField, MenuItem, Typography, Button, Chip } from "@mui/material";
import MyTable from "../../components/Schedule/MyTable";
import { useSnackbar } from "notistack";
import ApiService from "../../functions/apiService";
import CollapseComponent from "../../components/Schedule/CollapseComponent";
import ManagementHeaderNav from "../../components/HeadersNav/ManagementHeaderNav";
import StatusInTable from "../../components/StatusInTable/StatusInTable";
import AuthContext from "../../context/AuthContext";
import ButtonTheme from "../../components/ThemeButton/ThemeButton";
import AcceptShiftHeader from "./AcceptShiftHeader";
import { Row, Col } from "react-bootstrap";
import '../../components/Layout/layout.css'
import EmptyState from "../../components/Error/EmptyState";
import { toast } from 'react-toastify';
// import EmptyState from "../../components/Error/EmptyState";
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import moment from "moment";
import { varFormatTime } from "../../utils/helperFunctions";
import { Modal } from "react-bootstrap";

const AcceptShifts = () => {
  const { user, pages, pagesName , v3Data } = useContext(AuthContext);
  let pageView = Object.keys(pagesName).includes("V3_ACCEPT_SHIFT_VIEW") ? pagesName.V3_ACCEPT_SHIFT_VIEW : "normal";
  const [loading, setLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [rows2, setRows2] = useState([]);
  const [type, setType] = useState(1);
  const [saving, setSaving] = useState(false);
  const [acceptLength, setAcceptLength] = useState(0);
  const [swapsLength, setSwapsLength] = useState(0);
  const [dropdownArr, setDropdownArr] = useState([])
  const [dropdownMax, setDropdownMax] = useState(25)
  const [preferenceArr, setPreferenceArr] = useState([])
  const [reload, setReload] = useState(false)
  const [offered, setOffered] = useState(0);
  const [showText, setShowText] = useState(false)
  const [rfpText, setRfpText] = useState('')
  const [rfpData, setRfpData] = useState([])
  const [rowSelectionModel, setRowSelectionModel] = useState([]);
	const [overtimeSwaps , setOverTimeSwaps] = useState([]);
	const [overtimeSwapsLength , setOverTimeSwapsLength] = useState(0);
  const [rows3, setRows3] = useState([]);
  const [rows4, setRows4] = useState([]);
  const [rows5, setRows5] = useState([]);
  const [posLength, setPosLength] = useState(0);
  const [viewType, setViewType] = useState('offered')
  const [callBackLength, setCallBackLength] = useState(0);
  const [values, setValues] = useState(v3Data?.CALLBACK_TEMPLATE_PAGE === 'true' ? 4 : 0);
  const [monthlyPassModal , setMonthlyPassModal] = useState(false);
  const [threeDayPassModal , setThreeDayPassModal] = useState(false);
  const [monthlyData , setMonthlyData] = useState([]);
  const [threeShiftData , setThreeShiftData] = useState([]);
  const [showMonthlyButton , setShowMonthlyButton] = useState(false);
  const [showThreeShiftButton , setShowThreeShiftButton] = useState(false);

  const loadData = () => {
    setLoading(true);
    ApiService.get("/openShift")
      .then(({ data }) => {
        setRows(data.Schedule);
        setLoading(false);
        const requestedArray = data.Schedule.flatMap(scheduleItem =>
          scheduleItem.RequestArray.filter(item => item.StatusCode === "Offered")
        );
        setAcceptLength(requestedArray.length);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const loadRfpData = () => {
    setLoading(true);
    ApiService.get("/rfp-user-list")
      .then(({ data }) => {
        setLoading(false)
        var tempArr = data?.data?.map((rfp, i) => { return { id: i + 1, ...rfp } })
        setRfpData(tempArr);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const loadPosData = () => {
    setLoading(true);
    ApiService.get("/position-employee-assignment-list")
      .then(({ data }) => {
        setRows3(data?.Schedule);
        setPosLength(data?.count);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const loadCallBackData = () => {
    setLoading(true);
    ApiService.get("/callback-employee-requests")
      .then(({ data }) => {
        setRows5(data?.Schedule);
        setCallBackLength(data?.count);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const CallbackAction = (row , decision) => {
    setSaving(true);
    ApiService.post("/callback-employee-decision", {
      Shift_Date : row?.Shift_Date,
      Shift_Number : row?.Shift_Number,
			Decision : decision
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        loadCallBackData()
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
      });
  };

  const PrePosAction = (row , decision) => {
    setSaving(true);
    ApiService.post("/savePositionAssignmentUserPreference", {
      Shift_Date : row?.Shift_Date,
      Shift_Code : row?.Shift_Code,
      Position_Assignment_Id : row?.Position_Assignment_Id,
			Action : decision
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        loadPrePosData()
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
      });
  };

  const PrePosActionRevert = (id) => {
    setSaving(true);
    ApiService.post("/cancelPositionAssignmentUserPreference", {
      Preference_Id : id,
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        loadPrePosData()
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
      });
  };

  const loadPrePosData = () => {
    setLoading(true);
    ApiService.get("/openPositionAssignmentUserPreferenceList")
      .then(({ data }) => {
        setRows4(data?.Schedule);
        setPosLength(data?.count);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  const loadDataSwaps = () => {
    setLoading(true);
    ApiService.get("/swap-accept-list")
      .then(({ data }) => {
        setRows2(data.Schedule);
        const requestedArray = data.Schedule.flatMap(scheduleItem =>
          scheduleItem.RequestArray.filter(item => item.StatusCode === "Requested")
        );
        setSwapsLength(requestedArray.length);
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

	const loadDataOvertimeSwaps = () => {
		setLoading(true)
    ApiService.post("/ot-swap-user-received-list")
      .then((data) => {
				setLoading(false)
				setOverTimeSwaps(data?.data)
				setOverTimeSwapsLength(data?.data?.length)
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  };

  useEffect(() => {
    if (pages.includes("ACCEPT_SHIFT_PASS")) {
      loadRfpData()
    }
    loadData();
		loadPosData()
    loadCallBackData()
    loadDataSwaps();
		loadDataOvertimeSwaps();
  }, []);

  const filterFunc = (obj, caseNum) => {
    let newArr;
    if (caseNum === 2) {
      newArr = obj.RequestArray.filter((row) => row.StatusCode === "O");
    } else {
      newArr = obj.RequestArray.filter((row) => row.StatusCode == "Offered");
    }
    return { ...obj, RequestArray: newArr };
  };

  const filteredRows = useMemo(() => {
    if (!rows || rows.length === 0) return [];

    switch (type) {
      case 1:
        return rows.map((r) => filterFunc(r, 3)).filter(r => r.RequestArray.length > 0);
      case 2:
        return rows.map((r) => filterFunc(r, 2)).filter(r => r.RequestArray.length > 0);
      case 3:
        return rows;
      default:
        return [];
    }
  }, [rows, type]);

  const formatDate = (dateObj) => {
    let day = String(dateObj.getDate());
    let formattedDay = day;
    let dateStr = String(dateObj);
    const dateStrArr = dateStr.split(" ");

    if (day.endsWith("1") && day !== "11") {
      formattedDay += "st";
    } else if (day.endsWith("2") && day !== "12") {
      formattedDay += "nd";
    } else if (day.endsWith("3") && day !== "13") {
      formattedDay += "rd";
    } else {
      formattedDay += "th";
    }
    return `${dateStrArr[0]} ${formattedDay} ${dateStrArr[1]} ${dateStrArr[3]}`;
  };

  const acceptOpenShift = (row) => {
    //openShiftTimerAction
    setSaving(true);
    ApiService.post("/openShiftTimerAction", {
      Action: "accept",
      EmpCode: row.EmpCode,
      ShiftCode: row.ShiftNumber,
      ShiftDate: row.ShiftDate,
    })
      .then((data) => {
        setSaving(false);
        loadData();
        toast.success(data?.message)
      })
      .catch((error) => {
        setSaving(false);
        if (error.data != undefined) {
          toast.error(error?.data?.message || error?.data || 'error')
        } else {
          toast.error("Error")
        }

      });
  };

  const RejectShift = (row) => {
    setSaving(true);
    ApiService.post("/rejectShift", {
      Action: "reject",
      EmpCode: row.EmpCode,
      Shift_Number: row.ShiftNumber,
      Shift_Date: row.ShiftDate,
    })
      .then((data) => {
        setSaving(false);
        loadData();
        toast.success(data?.message)
      })
      .catch((error) => {
        setSaving(false);
        if (error.data != undefined) {
          toast.error(error?.data?.message)
        } else {
          toast.error("Error")
        }

      });
  };

  const acceptSwapsShift = (row , decision) => {
    setSaving(true);
    ApiService.post("/swap-accept", {
      ShiftCode: row.ShiftNumber,
      ShiftDate: row.ShiftDate,
			decision : decision,
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        loadDataSwaps();
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
      });
  };

	const PosShiftAction = (row, decision) => {
	setSaving(true);
	ApiService.post("/accept-position-shift", {
		Log_Id: row?.LogId,
		Action: decision,
	})
		.then((data) => {
			setSaving(false);
			loadPosData();
			toast.success(data?.message)
		})
		.catch((error) => {
			setSaving(false);
			if (error.data != undefined) {
				toast.error(error?.data?.error)
			} else {
				toast.error("Error")
			}

		});
  };

  useEffect(() => {
    var tempArr = []
    for (let i = 1; i <= dropdownMax; i++)(
      tempArr.push({ label: `Pref ${i}`, value: i })
    )
    setDropdownArr(tempArr)
  }, [])

  useEffect(() => {
    let tempArr = []
    filteredRows?.length > 0 && filteredRows?.map((item) => {
      item.RequestArray.length > 0 && item?.RequestArray.map((obj, i) => {
        if (obj?.PreferenceData) {
          let newObj = { shift: obj?.ShiftCode, pref: obj?.PreferenceData?.Value, date: obj?.ShiftDate, isDetail: obj?.DetailType != null }
          tempArr.push(newObj)
        }
      })
    })
    setPreferenceArr(tempArr)
  }, [filteredRows])
  const onDropdownChange = async (val, row, oldVal = '') => {
    if (val == 0 && oldVal != '') {
      setLoading(true)
      ApiService.post("/deletePrePreference", {
        "OrigEmpCode": user.Emp_Code,
        "ShiftDate": row?.ShiftDate,
        "ShiftNumber": row?.ShiftNumber,
        "ShiftCode": row?.ShiftCode,
        "Value": oldVal
      })
        .then((data) => {
          setLoading(false)
          toast.success(data?.message)
          loadData()
        })
        .catch((error) => {
          setLoading(false)
          toast.error(error?.data?.message)
          loadData()
        });
    }
    else {
      var canSetPref = false;
      if (row.DetailType != null) {
        if (val != 1 && row.DetailType != null && !preferenceArr.find((a) => a.pref == val - 1 && a.date == row?.ShiftDate && a.isDetail)) {
          alert(`Pref ${val - 1} is not set for ${v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'} on ${row?.ShiftDate}`)
        }
        else if (row.DetailType != null && preferenceArr.find((a) => a.pref == val && a.date == row?.ShiftDate && a.isDetail)) {
          alert(`Pref ${val} is already set for ${v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'} on ${row?.ShiftDate}`)
        }
        else {
          canSetPref = true
        }
      }
      else if (row.DetailType == null) {
        if (val != 1 && !preferenceArr.find((a) => a.pref == val - 1 && a.shift == row?.ShiftCode && a.date == row?.ShiftDate && !a.isDetail)) {
          alert(`Pref ${val - 1} is not set for ${row?.ShiftName} shift on ${row?.ShiftDate}`)
        }
        else if (preferenceArr.find((a) => a.pref == val && a.shift == row?.ShiftCode && a.date == row?.ShiftDate && !a.isDetail)) {
          alert(`Pref ${val} is already set for ${row?.ShiftName} shift on ${row?.ShiftDate}`)
        }
        else {
          canSetPref = true
        }
      }

      if (canSetPref) {
        setLoading(true)
        ApiService.post("/savePrePreference", {
          "OrigEmpCode": user.Emp_Code,
          "ShiftDate": row?.ShiftDate,
          "ShiftNumber": row?.ShiftNumber,
          "ShiftCode": row?.ShiftCode,
          "Value": val,
          "Type": row.DetailType != null ? 'DETAIL' : ''
        })
          .then((data) => {
            setLoading(false)
            toast.success(data?.message)
            loadData()
          })
          .catch((error) => {
            setLoading(false)
            toast.error(error?.data?.message)
            loadData()
          });
      }
    }
  }

  const columns = [
    ...(pages.includes('ACCEPT_SHIFT_PRE_PREFERENCE') ? [
      {
        field: "Preference",
        headerName: "",
        flex: 1,
        minWidth: 170,
        renderCell: (params) => {
          if ((params?.row?.ShowPreference || params?.row?.DetailType != null) && params.row.StatusCode == "O") {
            return (
              <TextField
                className="mt-1 w-100"
                color="secondary"
                variant="outlined"
                select
                size='small'
                InputProps={{
                  sx: {
                    height: '35px',
                    borderRadius: '20px',
                    fontSize: '14px'
                  }
                }}
                placeholder="Sel preference"
                value={params?.row?.PreferenceData ? parseInt(params?.row?.PreferenceData?.Value) : 0}
                onChange={(e) =>
                  onDropdownChange(e.target.value, params?.row, params?.row?.PreferenceData ? parseInt(params?.row?.PreferenceData?.Value) : '')
                }
              // disabled={params?.row?.PreferenceData ? true : false}
              >
                <MenuItem value={0}>
                  Sel preference
                </MenuItem>
                {dropdownArr.map((item) => (
                  <MenuItem value={item?.value}>
                    {item?.label}
                  </MenuItem>
                ))}
              </TextField>
            )
          }
        }
      },
    ] :
      // pages.includes('ACCEPT_SHIFT_PRE_BID') ?
      //   [{
      //     field: "Preference",
      //     headerName: "",
      //     flex: 1,
      //     maxWidth: 300,
      //     minWidth: pages.includes('ACCEPT_SHIFT_PRE_DECLINE') ? 275 : 160,
      //     renderCell: (params) => {
      //       return (
      //         <Row className="w-100">
      //           <Col md={'auto'}>
      //             <div className="btn-pill">
      //               <img src='/images/check.png' style={{ width: 12, height: 12, marginRight: 10 }} />
      //               Pre Accept
      //             </div>
      //           </Col>
      //           {pages.includes('ACCEPT_SHIFT_PRE_DECLINE') &&
      //             <Col md={'auto'} className="p-0">
      //               <div className="btn-pill">
      //                 <img src='/images/cross.png' style={{ width: 12, height: 12, marginRight: 10 }} />
      //                 Pre Decline
      //               </div>
      //             </Col>
      //           }
      //         </Row>
      //       )
      //     }
      //   }]
      //   :
      [{
        field: "o",
        headerName: "",
        flex: 1,
        maxWidth: 0,
        padding: 0
      }]),
    {
      field: "PositionName",
      headerName: "Position",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "EmpName",
      headerName: "Name",
      flex: 1,
      minWidth: 120,
    },
    {
      field: "ShiftName",
      headerName: "Shift",
      flex: 0,
      minWidth: 170,
      valueGetter: (params) => `${varFormatTime(params.row.ShiftName, user?.Time_Format)} ${params.row.DetailType != null ? `(${v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'})` : ""}`,
    },
    {
      field: "RequestedName",
      headerName: " ",
      flex: 1,
      minWidth: 240,
      valueGetter: (params) =>
        params.row.RequestedName + " " + params.row.AssignmentText,
    },
    {
      field: "StatusText",
      headerName: "Status",
      flex: 1,
      minWidth: 110,
      renderCell: (params) => {
        if (params.row.StatusName) {
          return (
            <StatusInTable
              StatusText={params.row.StatusName}
              StatusColor={params.row.StatusColor}
            />
          );
        }
        return <span></span>;
      },
    },
    ...(values == 0 ? [
      {
        field: "Action",
        headerName: "Actions",
        flex: 0,
        minWidth: 240,
        renderCell: (params) => {
          return (
            <>
              {(params.row.EmpCode != user.Emp_Code && params.row.StatusCode == "Offered" && params.row.AdminAcceptRequired == false) &&
                <>
                <ButtonTheme
                  disable={saving}
                  color="DarkGreen"
                  className="rounded-2"
                  onClick={() => { acceptOpenShift(params.row) }}
                >
                  Accept
                </ButtonTheme>
                </>
                
              }
							{(params.row.EmpCode != user.Emp_Code && params.row.StatusCode == "Offered" && params.row.AdminAcceptRequired == true) && (
                <div>
                  Contact To Accept
                </div>
              )}
							{(params.row.EmpCode != user.Emp_Code && params.row.StatusCode == "Offered") &&
                <>
                  <ButtonTheme
										disable={saving}
										color="red"
										className="rounded-2 mx-2"
										onClick={() => RejectShift(params.row)}
									>
										Reject
									</ButtonTheme>
                </>
                
              }
              {pages.includes('ACCEPT_SHIFT_PRE_BID') && params.row.StatusCode == "O" &&
                <ButtonTheme
                  color={params.row.PreBidData ? "red" : 'DarkGreen'}
                  className="rounded-2"
                  onClick={() => {
                    if (params.row.PreBidData) {
                      acceptRemoveBid(params.row, 'remove')
                    }
                    else {
                      acceptRemoveBid(params.row, 'ACCEPT')
                    }
                  }}
                >
                  {params.row.PreBidData ? params.row.PreBidData.Value == 'DECLINE' ? 'Remove Pre-decline' : 'Remove Pre-accept' : 'Pre-Accept'}
                </ButtonTheme>
              }
              {pages.includes('ACCEPT_SHIFT_PRE_DECLINE') && (params?.row?.PreBidData == null) && (params.row.StatusCode == "O") &&
                <ButtonTheme
                  className="rounded-2 mx-2"
                  style={{ backgroundColor: '#000000' }}
                  onClick={() => acceptRemoveBid(params.row, 'DECLINE')}
                >
                  Pre-decline
                </ButtonTheme>
              }
            </>
          );
        },
      },
    ] : [
      {
        field: "Action",
        headerName: "Actions",
        flex: 0,
        minWidth: 240,
        renderCell: (params) => {
          if (params.row.EmpCode != user.Emp_Code) {
            if (
              params.row.StatusCode == "Requested"
            ) {
              return (
								<>	
									 <ButtonTheme
											disable={saving}
											color="DarkGreen"
											className="rounded-2"
											onClick={() => { acceptSwapsShift(params.row , "approve") }}
										>
											Accept
										</ButtonTheme>
										<ButtonTheme
											disable={saving}
											color="red"
											className="rounded-2 mx-2"
											onClick={() => acceptSwapsShift(params.row , "deny")}
										>
											Reject
										</ButtonTheme>
								</>
              );
            }
          }
        },
      },
    ])
  ];

  const rfpColumns = [
    {
      field: "date", headerName: "Date", flex: 1, minWidth: 250, maxWidth: 250,
      valueGetter: (params) => moment(params.row.Shift_Date).format('dddd Do MMMM YYYY'),
    },
    {
      field: "request", headerName: "Request", flex: 1, minWidth: 240, maxWidth: 270,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.row.Value}
        </div>
      ),
    },
    {
      field: "Status", headerName: "Status", flex: 1, minWidth: 240, maxWidth: 180,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.Status == 'DECLINED' ?
              <Chip
                style={{ textTransform: 'capitalize', backgroundColor: '#E627191A' }}
                variant="outlined" color='red'
                label={params?.row?.Status.toLowerCase()}
              />
              :
              params?.row?.Status == 'APPROVED' ?
                <Chip
                  sx={{ backgroundColor: '#01784F1A', color: '#01784F', border: '1px solid #01784F', textTransform: 'capitalize', }}
                  variant="outlined"
                  label={params?.row?.Status.toLowerCase()}
                />
                :
                <Chip
                  style={{ textTransform: 'capitalize', backgroundColor: '#FFA500', color: '#000' }}
                  label={params?.row?.Status.toLowerCase()}
                  className='requested-chip'
                />
            }
          </>
        )
      }
    },
  ];

  const monthlyColumns = [
    {
      field: "Shift_Date", headerName: "Shift Date", flex: 1, minWidth: 250, maxWidth: 250,
    },
    {
      field: "Value", headerName: "Value", flex: 1, minWidth: 300, maxWidth: 320,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.row.Value}
        </div>
      ),
    },
    {
      field: "Status", headerName: "Status", flex: 1, minWidth: 240, maxWidth: 180,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.Status == 'DECLINED' ?
              <Chip
                style={{ textTransform: 'capitalize', backgroundColor: '#E627191A' }}
                variant="outlined" color='red'
                label={params?.row?.Status.toLowerCase()}
              />
              :
              params?.row?.Status == 'APPROVED' ?
                <Chip
                  sx={{ backgroundColor: '#01784F1A', color: '#01784F', border: '1px solid #01784F', textTransform: 'capitalize', }}
                  variant="outlined"
                  label={params?.row?.Status.toLowerCase()}
                />
                :
                <Chip
                  style={{ textTransform: 'capitalize', backgroundColor: '#FFA500', color: '#000' }}
                  label={params?.row?.Status.toLowerCase()}
                  className='requested-chip'
                />
            }
          </>
        )
      }
    },
  ];

  const threeShiftColumns = [
    {
      field: "Shift_Date", headerName: "Shift Date", flex: 1, minWidth: 250, maxWidth: 250,
    },
    {
      field: "Value", headerName: "Value", flex: 1, minWidth: 300, maxWidth: 320,
      renderCell: (params) => (
        <div style={{ whiteSpace: 'normal', wordWrap: 'break-word' }}>
          {params.row.Value}
        </div>
      ),
    },
    {
      field: "Status", headerName: "Status", flex: 1, minWidth: 240, maxWidth: 180,
      renderCell: (params) => {
        return (
          <>
            {params?.row?.Status == 'DECLINED' ?
              <Chip
                style={{ textTransform: 'capitalize', backgroundColor: '#E627191A' }}
                variant="outlined" color='red'
                label={params?.row?.Status.toLowerCase()}
              />
              :
              params?.row?.Status == 'APPROVED' ?
                <Chip
                  sx={{ backgroundColor: '#01784F1A', color: '#01784F', border: '1px solid #01784F', textTransform: 'capitalize', }}
                  variant="outlined"
                  label={params?.row?.Status.toLowerCase()}
                />
                :
                <Chip
                  style={{ textTransform: 'capitalize', backgroundColor: '#FFA500', color: '#000' }}
                  label={params?.row?.Status.toLowerCase()}
                  className='requested-chip'
                />
            }
          </>
        )
      }
    },
  ];

	  const columns2 = [
    {
      field: "PositionName",
      headerName: "Position",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "ShiftName",
      headerName: "Shift",
      flex: 0,
      minWidth: 170,
      valueGetter: (params) => `${varFormatTime(params.row.ShiftName, user?.Time_Format)} ${params.row.DetailType != null ? `(${v3Data?.V3_ALLOW_ALTER_LABEL_TEXTS === 'true' ? 'CPP' : 'Detail'})` : ""}`,
    },
    {
      field: "StatusText",
      headerName: "Status",
      flex: 1,
      minWidth: 110,
      renderCell: (params) => {
        if (params.row.StatusName) {
          return (
            <StatusInTable
              StatusText={params.row.StatusName}
              StatusColor={params.row.StatusColor}
            />
          );
        }
        return <span></span>;
      },
    },
      {
        field: "Action",
        headerName: "Actions",
        flex: 0,
        minWidth: 240,
        renderCell: (params) => {
              return (
								<>	
								{(params.row.Status != "A") && (params.row.Status != "D") ?
									<>
									<ButtonTheme
										disable={saving}
										color="DarkGreen"
										className="rounded-2"
										onClick={() => { PosShiftAction(params.row , "accept") }}
									>
										Accept
									</ButtonTheme>
									<ButtonTheme
										disable={saving}
										color="red"
										className="rounded-2 mx-2"
										onClick={() => PosShiftAction(params.row , "decline")}
									>
										Reject
									</ButtonTheme>
									</>
									: ""
								}
							</>
						);
					}
				}
			]

    const columns3 = [
    {
      field: "Position_Name",
      headerName: "Position",
      flex: 1,
      minWidth: 100,
    },
    {
      field: "Shift_Name",
      headerName: "Shift",
      flex: 0,
      minWidth: 170,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1,
      minWidth: 110,
      renderCell: (params) => {
          return (params.row.Status || 'OPEN')
      },
    },
      {
        field: "Action",
        headerName: "Actions",
        flex: 0,
        minWidth: 240,        
        renderCell: (params) => {
          return (
            <>
            {params?.row?.Status == null ?
            <>
                <ButtonTheme
                  color={params.row.PreBidData ? "red" : 'DarkGreen'}
                  className="rounded-2"
                  onClick={() => {
                      PrePosAction(params.row, 'accept')
                  }}
                >
                   Pre-Accept
                  </ButtonTheme>
                <ButtonTheme
                  className="rounded-2 mx-2"
                  style={{ backgroundColor: '#000000' }}
                  onClick={() => PrePosAction(params.row, 'decline')}
                >
                  Pre-Decline
                </ButtonTheme>
            </> :
                  <img src="/images/revert.png" width={22} height={22} style={{ cursor: 'pointer' }}
                    onClick={() => PrePosActionRevert(params?.row?.UserPreference?.ID)} />}
            </>
          );
        },
				}
			]

    const columns4 = [
    {
      field: "Assignment_Text",
      headerName: "Assignment",
      flex: 1,
      minWidth: 240,
    },
    {
      field: "Status",
      headerName: "Status",
      flex: 1,
      minWidth: 300,
      renderCell: (params) => {
          return (params.row.Response_Text)
      },
    },
      {
        field: "Action",
        headerName: "Actions",
        flex: 0,
        minWidth: 240,        
        renderCell: (params) => {
          return (
            params.row.Response_Text == "Declined" ? 
              <Button
                variant="contained"
                sx={{
                  backgroundColor: 'transparent',
                  color: '#E62719',
                  padding: '6px 40px',
                  boxShadow: 'none',
                  borderRadius:'30px',
                  border:'1px solid #E62719',
                  '&:hover': {
                    backgroundColor: 'transparent',
                    boxShadow: 'none',
                  },
                }}
              >
                {'Rejected'}
              </Button>
              : 
              params.row.Response_Text == "Accepted" ? 
              <Button
                  variant="contained"
                  sx={{
                    backgroundColor: 'transparent',
                    color: '#01784F',
                    padding: '6px 40px',
                    boxShadow: 'none',
                    borderRadius:'30px',
                    border:'1px solid #01784F',
                    '&:hover': {
                      backgroundColor: 'transparent',
                      boxShadow: 'none',
                    },
                  }}
                >
                  {'Accepted'}
                </Button>
                :
              <>
                <ButtonTheme
                  disable={params.row.Response_Text == "Declined"}
                  color="DarkGreen"
                  className="rounded-2"
                  onClick={() => { CallbackAction(params.row, 'accept') }}
                >
                  Accept
                </ButtonTheme>
                  <ButtonTheme
                    disable={params.row.Response_Text == "Declined"}
                    color="red"
                    className="rounded-2 mx-2"
                    onClick={() => CallbackAction(params.row, 'decline')}
                  >
                    Reject
                </ButtonTheme>
              </>
          );
        },
				}
			]

  const handleTabChange = (newValue) => {
    if (newValue === 0) {
      loadData();
    } else if (newValue === 1) {
      loadDataSwaps();
    } else if (newValue === 2) {
      loadDataOvertimeSwaps();
    } else if (newValue === 3) {
      loadPosData();
    } else if (newValue === 4) {
      loadCallBackData();
    }
  };

  useEffect(() => {
    handleTabChange(values);
  }, [values]);

  const acceptRemoveBid = (row, type) => {
    setSaving(true);
    let url = type == 'remove' ? '/deleteShiftPreBid' : '/addShiftPreBid';

    const payload = {
      ShiftDate: row.ShiftDate,
      ShiftNumber: row.ShiftNumber,
    };

    if (type === 'ACCEPT' || type === 'DECLINE') {
      payload.type = type;
    }

    ApiService.post(url, payload)
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        loadData();
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
      });
  }

  const onRowSelectionModelChange = (newRowSelectionModel) => {
    setRowSelectionModel(newRowSelectionModel);
  };

  const requestFreePass = () => {
    const selected = filteredRows.flatMap(day => day.RequestArray).find(r => r.id === rowSelectionModel[0]);
    ApiService.post("/request-rfp", {
      Shift_Number: selected?.ShiftNumber,
      Shift_Date: selected?.ShiftDate,
      txt_RFP: rfpText
    })
      .then((data) => {
        toast.success(data?.data?.message);
        setRowSelectionModel([])
        loadRfpData();
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  };

	const acceptOvertimeSwaps = (row , decision) => {
    setSaving(true);
    ApiService.post("/ot-swap-user-decision", {
      Shift_Date : row?.Shift_Date,
      Shift_Number : row?.Shift_Number,
			decision : decision
    })
      .then((data) => {
        setSaving(false);
        toast.success(data?.message)
        loadDataOvertimeSwaps();
      })
      .catch(({ data }) => {
        setSaving(false);
        toast.error(data?.message)
      });
  };

  const handleMonthlyPass = () => {
    const selected = filteredRows.flatMap(day => day.RequestArray).find(r => r.id === rowSelectionModel[0]);
    ApiService.post("/user-request-monthly-pass", {
      Shift_Number: selected?.ShiftNumber,
      Shift_Date: selected?.ShiftDate,
    })
      .then((data) => {
        toast.success(data?.data?.message);
        setRowSelectionModel([])
        setMonthlyPassModal(false)
        getMonthlyPassess();
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  };

  const handleThreeDayShiftPass = () => {
    const selected = filteredRows.flatMap(day => day.RequestArray).find(r => r.id === rowSelectionModel[0]);
    ApiService.post("/user-request-3shift-pass", {
      Shift_Number: selected?.ShiftNumber,
      Shift_Date: selected?.ShiftDate,
    })
      .then((data) => {
        toast.success(data?.data?.message || data?.message);
        setRowSelectionModel([])
        setThreeDayPassModal(false)
        getThreeShiftPassess();
      })
      .catch((error) => {
        toast.error(error?.data?.message)
      });
  };

  const getMonthlyPassess = () => {
    ApiService.get("/user-list-monthly-pass")
      .then((data) => {
        const result = data?.data?.result?.map((innerData , index) => ({
          ...innerData , 
          id : index + 1
        }))
        setMonthlyData(result)
        setShowMonthlyButton(data?.data?.show_button)
      })
      .catch((error) => {
        console.error('error')
      });
  };

  const getThreeShiftPassess = () => {
    ApiService.get("/user-list-3shift-pass")
      .then((data) => {
        const result = data?.data?.result?.map((innerData , index) => ({
          ...innerData,
          id : index + 1
        }))
        setThreeShiftData(result)
        setShowThreeShiftButton(data?.data?.show_button)
      })
      .catch((error) => {
        console.error('error')
      });
  };

  useEffect(()=>{
    getMonthlyPassess();
    getThreeShiftPassess();
  } , [])


  return (
    <>
      {/* <ManagementHeaderNav /> */}
      <Paper className="p-3" style={{ marginTop: '1rem', maxWidth: '93vw', overflowX: 'auto', }}>
        <div className="accept-container">
          <Grid
            container
            spacing={2}
            columns={{ xs: 8, sm: 8, md: 12 }}
          >
            <Grid item xs={12}>
              <div className='my-shifts'>
                <Grid container spacing={2} columns={{ xs: 8, sm: 8, md: 12 }}>
                  <Grid item xs={12}>
                    <Typography variant="h5">Accept Shifts</Typography>
                    <div className='py-3'>
                      <div className='d-flex justify-content-between flex-wrap '>
                        <div className='small-navigator'>
                          <AcceptShiftHeader
                            value={values}
                            setValue={setValues}
                            handleTabChange={handleTabChange}
                            acceptLength={acceptLength}
                            swapsLength={swapsLength}
														posLength={posLength}
                            callBackLength={callBackLength}
														overtimeSwapsLength = {overtimeSwapsLength}
                          />
                        </div>
                      </div>
                    </div>
                  </Grid>
                </Grid>
              </div>

              {values == 0 &&
                <div>
                  {loading && (
                    <Box className="w-100 d-flex justify-content-center align-items-center"
                      style={{ height: '500px' }}>
                      <CircularProgress />
                    </Box>
                  )}

                  {!loading &&
                    <>
                      <Box className='d-flex justify-content-between align-items-end'>
                        <form style={{ width: '25%' }}>
                          <Grid item xs={12} sm={12} md={12}>
                            <label>View</label>
                            <TextField
                              className="mt-1 w-100"
                              color="secondary"
                              variant="outlined"
                              select
                              size='small'
                              InputProps={{
                                sx: {
                                  height: '48px',
                                  fontSize: '14px'
                                }
                              }}
                              value={type}
                              onChange={(e) =>
                                setType(e.target.value)
                              }
                            >
                              <MenuItem value={3}>
                                All Shifts{" "}
                              </MenuItem>
                              <MenuItem value={2}>
                                Open Shifts{" "}
                              </MenuItem>
                              <MenuItem value={1}>
                                Offered Shifts{" "}
                              </MenuItem>
                            </TextField>
                          </Grid>
                        </form>

                        {pages.includes("ACCEPT_SHIFT_PASS") &&
                          <div className="d-flex" style={{ gap: 10 }}>
                            {showText &&
                              <TextField color='secondary' variant="outlined" label="Request free pass"
                                sx={{ height: "48px", "& .MuiInputBase-root": { height: "48px" } }}
                                onChange={(e) => setRfpText(e.target.value)}
                              />
                            }
                            {type == 1 &&
                              <>
                                <ButtonTheme color='primary' disabled={rowSelectionModel.length < 1}
                                  onClick={() => {
                                    if (!showText)
                                      setShowText(true)
                                    else
                                      requestFreePass()
                                  }}>
                                  Request Free Pass
                                </ButtonTheme>

                                {v3Data?.ACCEPT_SHIFT_MONTHLY_PASS && showMonthlyButton == true &&
                                  <ButtonTheme color='primary' disabled={rowSelectionModel.length < 1}
                                    onClick={() => {
                                      setMonthlyPassModal(true)
                                    }}>
                                    Monthly Pass
                                  </ButtonTheme>
                                }

                                {v3Data?.ACCEPT_SHIFT_3DAY_PASS &&  showThreeShiftButton == true &&
                                  <ButtonTheme color='primary' disabled={rowSelectionModel.length < 1}
                                    onClick={() => {
                                      setThreeDayPassModal(true)
                                    }}>
                                    3 Shift Pass
                                  </ButtonTheme>
                                }
                                
                              </>
                            }
                          </div>
                        }

                      </Box>
                      <Box
                        sx={{
                          maxWidth: "93vw",
                          overflowX: "auto",
                          background: "#FFF",
                        }}
                      >
                        <Grid container spacing={2} className='mt-1'>
                          {rows.length > 0 ? (
                            filteredRows.map((obj) => {
                              const d = new Date(obj.Date + "T00:00:00");
                              let newDate = formatDate(d);
                              if (obj.RequestArray.length > 0) {
                                return (
                                  <>
                                    {pageView === 'cardview' ?
                                      <Grid item xs={4}>
                                        <Box
                                          sx={{
                                            padding: '16px',
                                            backgroundColor: '#ffffff',
                                            borderRadius: '12px',
                                            border: '1px solid #EBECF0',
                                            boxShadow: `
                                              0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
                                              0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
                                              0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
                                            `,
                                          }}
                                        >
                                          <TableContainer>
                                            <Table aria-label="simple table">
                                              <TableHead>
                                                <TableRow>
                                                  <TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
                                                    Shift
                                                  </TableCell>
                                                  <TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
                                                    {moment(obj.Date).format('MM/DD/YY')}
                                                  </TableCell>
                                                </TableRow>
                                              </TableHead>
                                              <TableBody>
                                                {obj.RequestArray.map((row) => (
                                                  <TableRow key={row.name} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
                                                    <TableCell
                                                      component="th"
                                                      scope="row"
                                                      style={{
                                                        padding: '0px',
                                                        fontSize: '16px',
                                                        fontWeight: 600,
                                                        fontFamily: 'karla',
                                                        padding: '7px',
                                                        width: '50%'
                                                      }}
                                                    >
                                                      {row?.ShiftType === 'Details' ?
                                                        row?.StartTime >= "08:00:00" && row?.StartTime <= "17:59:59" ? `Day (${varFormatTime(row?.ShiftName, user?.Time_Format)})` : `Night (${varFormatTime(row?.ShiftName, user?.Time_Format)})`
                                                        : row?.ShiftType
                                                      }

                                                      {row?.ShiftType === 'Day' &&
                                                        <img src="/images/day.svg" height="20px" width="20px" style={{ marginLeft: '10px' }} />
                                                      }

                                                      {row?.ShiftType === 'Night' &&
                                                        <img src="/images/night.svg" height="18px" width="18px" style={{ marginLeft: '10px' }} />
                                                      }

                                                      {!["Day", "Night"].includes(row?.ShiftType) && (
                                                        <img
                                                          src={
                                                            row?.StartTime >= "08:00:00" && row?.StartTime <= "17:59:59"
                                                              ? "/images/day.svg"
                                                              : "/images/night.svg"
                                                          }
                                                          height="20px"
                                                          width="20px"
                                                          style={{ marginLeft: "10px" }}
                                                        />
                                                      )}
                                                    </TableCell>
                                                    <TableCell align="right" style={{ padding: '0px', padding: '7px 0px' }}>
                                                      {row.EmpCode !== user.Emp_Code && (
                                                        <>
                                                          {values === 0 && row.StatusCode === 'Offered' && (
                                                            <div>
                                                              <ButtonTheme
                                                                disable={saving}
                                                                color="DarkGreen"
                                                                className="rounded-2 mx-2 px-3"
                                                                onClick={() => acceptOpenShift(row)}
                                                              >
                                                                Accept
                                                              </ButtonTheme>
                                                              <ButtonTheme
                                                                disable={saving}
                                                                color="red"
                                                                className="rounded-2 px-3"
                                                                onClick={() => RejectShift(row)}
                                                              >
                                                                Reject
                                                              </ButtonTheme>
                                                            </div>
                                                          )}
                                                          {values === 0 && row.StatusCode === 'O' && (
                                                            <div className="d-flex justify-content-end" style={{ gap: 10 }}>
                                                              <ButtonTheme
                                                                disable={saving}
                                                                color="red"
                                                                className="rounded-2"
                                                                style={{ padding: '6px 34px' }}
                                                              >
                                                                Open Position
                                                              </ButtonTheme>
                                                            </div>
                                                          )}
                                                        </>
                                                      )}
                                                    </TableCell>
                                                  </TableRow>
                                                ))}
                                              </TableBody>
                                            </Table>
                                          </TableContainer>
                                        </Box>
                                      </Grid>
                                      :
                                      <Grid item xs={12}>
                                        <CollapseComponent
                                          key={newDate}
                                          rows={obj.RequestArray}
                                          columns={columns}
                                          name={newDate}
                                          open={true}
                                          onRowSelectionModelChange={onRowSelectionModelChange}
                                          rowSelectionModel={rowSelectionModel}
                                        />
                                      </Grid>
                                    }
                                  </>
                                );
                              }
                            })
                          ) : (
                            <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 425, width: "100%" }}>
                              <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                              <span className='mt-4' style={{ color: '#555555' }}>
                                No Shifts Found
                              </span>
                            </div>
                          )}
                        </Grid>
                      </Box>

                    </>
                  }

                  {filteredRows.length === 0 && rows.length > 0 &&
                    <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 425, width: "100%" }}>
                      <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                      <span className='mt-4' style={{ color: '#555555' }}>
                        No Shifts Found
                      </span>
                    </div>
                  }

                  {(pages.includes("ACCEPT_SHIFT_PASS")) && (!loading) &&
                    <CollapseComponent
                      key={'newDate'}
                      rows={rfpData}
                      columns={rfpColumns}
                      name={'Request Free Passes'}
                      checkboxSelection={false}
                      open={true}
                    />
                  }
                </div >
              }

              {values == 0 && v3Data?.ACCEPT_SHIFT_MONTHLY_PASS &&
                <div>
                  <CollapseComponent
                      key={'newDate'}
                      rows={monthlyData}
                      columns={monthlyColumns}
                      name={'Monthly Passes'}
                      checkboxSelection={false}
                      open={true}
                    />
                </div>
              }

              {values == 0 && v3Data?.ACCEPT_SHIFT_3DAY_PASS && 
                <div>
                  <CollapseComponent
                    key={'newDate'}
                    rows={threeShiftData}
                    columns={threeShiftColumns}
                    name={'3 Shift Passes'}
                    checkboxSelection={false}
                    open={true}
                  />
                </div>
              }


              {values == 1 &&
                <div>
                  {loading && (
                    <Box className="w-100 d-flex justify-content-center align-items-center"
                      style={{ height: '500px' }}>
                      <CircularProgress />
                    </Box>
                  )}
                  {!loading && (
                    <Box
                      sx={{
                        maxWidth: "93vw",
                        overflowX: "auto",
                        background: "#FFF",
                      }}
                    >
                      {rows2.length > 0 ? (
                        rows2.map((obj) => {
                          const d = new Date(obj.Date + "T00:00:00");
                          let newDate = formatDate(d);
                          if (
                            obj.RequestArray.length > 0
                          ) {
                            return (
                              <CollapseComponent
                                key={newDate}
                                rows={obj.RequestArray}
                                columns={columns}
                                name={newDate}
                                checkboxSelection={false}
                                open={true}
                              />
                            );
                          }
                        })
                      ) : (
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500, width: "100%" }}>
                          <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                          <span className='mt-4' style={{ color: '#555555' }}>
                            No Shifts Found
                          </span>
                        </div>
                      )}
                    </Box>
                  )}
                </div>
              }

							{values == 2 &&
                <div>
                  {loading && (
                    <Box className="w-100 d-flex justify-content-center align-items-center"
                      style={{ height: '500px' }}>
                      <CircularProgress />
                    </Box>
                  )}
                  {!loading && (
                    <Grid container spacing={2} className="mb-3">
											{overtimeSwaps.length > 0 ? (
												overtimeSwaps.map((obj) => {
													{
														return (
															<Grid item xs={4}>
																<Box
																	sx={{
																		padding: '16px',
																		backgroundColor: '#ffffff',
																		borderRadius: '12px',
																		border: '1px solid #EBECF0',
																		boxShadow: `
																		0px 3.26px 9.79px rgba(31, 64, 148, 0.02),
																		0px 6.53px 7.18px rgba(22, 38, 61, 0.06),
																		0px 1.96px 3.92px rgba(4, 43, 141, 0.03)
																	`,
																	}}
																>
																	<TableContainer>
																		<Table aria-label="simple table">
																			<TableHead>
																				<TableRow>
																					<TableCell align="left" style={{ padding: '0px', paddingBottom: '16px', fontSize: '16px', fontWeight: 550, fontFamily: 'karla' }}>
																						Shift
																					</TableCell>
																					<TableCell align="right" style={{ fontSize: '16px', fontWeight: 550, fontFamily: 'karla', padding: '0px', paddingBottom: '16px', }}>
																						{obj?.swap_by_shift_details?.Shift_Code == '2' ? 'Day' : 'Night'}
																					</TableCell>
																				</TableRow>
																			</TableHead>
																			<TableBody>
																				<TableRow key={obj.Value} sx={{ '&:last-child td, &:last-child th': { border: 0 } }}>
																					<TableCell
																						component="th"
																						scope="row"
																						style={{
																							padding: '0px',
																							fontSize: '14px',
																							fontFamily: 'karla',
																							padding: '7px',
																							color: '#555555',
																						}}
																					>
																						<p style={{ marginBottom: '3px' }}>
																							Requested by :
																							<span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
																								{obj?.swap_request_by?.fullName}
																							</span>
																						</p>

																						<p style={{ marginBottom: '3px' }}>
																							Shift :
																							<span style={{ color: '#000000', fontWeight: '400 !important', marginLeft:'4px' }}>
																								{moment(obj?.swap_by_shift_details?.Shift_Date).format('MM/DD/YYYY')}
																							</span>
																						</p>

																						<p>
																							Status :
																							<span style={{ color: '#000000', fontWeight: '400 !important' , marginLeft:'4px' }}>
																								{obj.Status}
																							</span>
																						</p>
			
																						<div style={{ display: 'flex', justifyContent: 'space-between' }}>
																							{obj?.Status == 'PENDING' ?
																								<div>
																									<ButtonTheme
																										disable={saving}
																										color="DarkGreen"
																										className="rounded-2"
																										onClick={() => acceptOvertimeSwaps(obj , 'approve')}
																									>
																										Accept
																									</ButtonTheme>
																									<ButtonTheme
																										disable={saving}
																										color="red"
																										className="rounded-2 mx-2"
																										onClick={() => acceptOvertimeSwaps(obj , 'deny')}
																									>
																										Reject
																									</ButtonTheme>
																								</div>
																								: 
																								obj?.Status == 'REJECTED' ? 
																								<div className="mt-1">
																									<Chip
																										sx={{ backgroundColor: 'rgba(230, 39, 25, 0.2)', color: '#E62719', border: '1px solid #E62719', textTransform: 'capitalize', }}
																										variant="outlined"
																										label= 'Rejected'
																									/>
																								</div>
																								:
																								<div className="mt-1">
																									<Chip
																										sx={{ backgroundColor: '#01784F1A', color: '#01784F', border: '1px solid #01784F', textTransform: 'capitalize', }}
																										variant="outlined"
																										label= 'Accepted'
																									/>
																								</div>
																							}
																						</div>
																					</TableCell>
																				</TableRow>
																			</TableBody>
																		</Table>
																	</TableContainer>
																</Box>
															</Grid>
														);
													}
												})
											) : (
												<div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500, width: "100%" }}>
                          <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                          <span className='mt-4' style={{ color: '#555555' }}>
                            No Shifts Found
                          </span>
                        </div>
											)}
										</Grid>
                  )}
                </div>
              }

              {values == 3 &&
                <div>
                  {loading && (
                    <Box className="w-100 d-flex justify-content-center align-items-center"
                      style={{ height: '500px' }}>
                      <CircularProgress />
                    </Box>
                  )}
                  {!loading &&
                   <form style={{ width: '25%' }}>
                      <Grid item xs={12} sm={12} md={12} style={{marginBottom:'1rem'}}>
                        <label>View</label>
                        <TextField
                          className="mt-1 w-100"
                          color="secondary"
                          variant="outlined"
                          select
                          size='small'
                          InputProps={{
                            sx: {
                              height: '48px',
                              fontSize: '14px'
                            }
                          }}
                          value={viewType}
                          onChange={(e) => {
                            const selectedView = e.target.value;
                            setViewType(selectedView);

                            if (selectedView === "offered") {
                              loadPosData();
                              setRows4([]);
                            } else if (selectedView === "open") {
                              loadPrePosData();
                              setRows3([]);
                            }
                          }}
                        > 
                          <MenuItem value="open">Open Shifts</MenuItem>
                          <MenuItem value="offered">Offered Shifts</MenuItem>
                        </TextField>
                      </Grid>
                    </form>}

                  {!loading && (
                    <Box
                      sx={{
                        maxWidth: "93vw",
                        overflowX: "auto",
                        background: "#FFF",
                      }}
                    >
                      {(viewType === "offered" ? rows3 : rows4).length > 0 ? (
                        (viewType === "offered" ? rows3 : rows4).map((obj, index) => {
                          const d = new Date(obj.Date + "T00:00:00");
                          let newDate = formatDate(d);
                          if (obj?.RequestArray?.length > 0) {
                            return (
                              <CollapseComponent
                                key={index}
                                rows={obj.RequestArray}
                                columns={viewType === "offered" ? columns2 : columns3}
                                name={newDate}
                                checkboxSelection={false}
                                open={true}
                              />
                            );
                          }
                          return null;
                        })
                      ) : (
                          <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500, width: "100%" }}>
                            <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                            <span className='mt-4' style={{ color: '#555555' }}>
                              No Shifts Found
                            </span>
                          </div>
                        )}
                    </Box>
                  )}
                </div>
              }

              {values == 4 &&
                <div>
                  {loading && (
                    <Box className="w-100 d-flex justify-content-center align-items-center"
                      style={{ height: '500px' }}>
                      <CircularProgress />
                    </Box>
                  )}
                  {!loading && (
                    <Box
                      sx={{
                        maxWidth: "93vw",
                        overflowX: "auto",
                        background: "#FFF",
                      }}
                    >
                      {rows5.length > 0 ? (
                        rows5.map((obj) => {
                          const d = new Date(obj.Date + "T00:00:00");
                          let newDate = formatDate(d);
                          if (
                            obj.RequestArray.length > 0
                          ) {
                            return (
                              <CollapseComponent
                                key={newDate}
                                rows={obj.RequestArray}
                                columns={columns4}
                                name={newDate}
                                checkboxSelection={false}
                                open={true}
                              />
                            );
                          }
                        })
                      ) : (
                        <div className='d-flex flex-column align-items-center justify-content-center' style={{ height: 500, width: "100%" }}>
                          <img src='/images/blur-logo.png' style={{ height: 200, width: 250 }} />
                          <span className='mt-4' style={{ color: '#555555' }}>
                            No Shifts Found
                          </span>
                        </div>
                      )}
                    </Box>
                  )}
                </div>
              }
            </Grid>
          </Grid>
        </div>
      </Paper>

      <Modal show={monthlyPassModal} size="md"
        onHide={() => { setMonthlyPassModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>Monthly Pass</Modal.Title>
        </Modal.Header>

        <Modal.Body className='px-3'>
          <Row className='mx-1'>
              Are you sure you want to monthly pass ?
          </Row>
          
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={() => setMonthlyPassModal(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => handleMonthlyPass()}>
                Yes
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>

      <Modal show={threeDayPassModal} size="md"
        onHide={() => { setThreeDayPassModal(false) }}>
        <Modal.Header closeButton>
          <Modal.Title>3 Shift Pass Modal</Modal.Title>
        </Modal.Header>

        <Modal.Body className='px-3'>
          <Row className='mx-1'>
              Are you sure you want to 3 shift pass ?
          </Row>
          
          <Row>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='#f5f5f5' className='mt-4' onClick={() => setThreeDayPassModal(false)}>
                Cancel
              </ButtonTheme>
            </Col>
            <Col md='auto'>
              <ButtonTheme type='submit' variant="filled" color='primary' className='mt-4' onClick={() => handleThreeDayShiftPass()}>
                Yes
              </ButtonTheme>
            </Col>
          </Row>
        </Modal.Body>
      </Modal>
    </>
  );
};

export default AcceptShifts;